"use client";
import { createElement, createHook, forwardRef } from "@ariakit/react-utils";
//#region src/visually-hidden/visually-hidden.tsx
const TagName = "span";
/**
* Returns styles to visually hide an element while keeping it accessible to
* screen readers.
*/
function getVisuallyHiddenStyle(style) {
	return {
		borderWidth: 0,
		clipPath: "inset(50%)",
		height: "1px",
		margin: "-1px",
		overflow: "hidden",
		padding: 0,
		position: "absolute",
		whiteSpace: "nowrap",
		width: "1px",
		...style
	};
}
/**
* Returns props to create a `VisuallyHidden` component. When applying the props
* returned by this hook to a component, the component will be visually hidden,
* but still accessible to screen readers.
* @see https://ariakit.com/components/visually-hidden
* @example
* ```jsx
* const props = useVisuallyHidden();
* <a href="#">
*   Learn more<Role {...props}> about the Solar System</Role>.
* </a>
* ```
*/
const useVisuallyHidden = createHook(function useVisuallyHidden(props) {
	props = {
		...props,
		style: getVisuallyHiddenStyle(props.style)
	};
	return props;
});
/**
* Renders an element that's visually hidden, but still accessible to screen
* readers.
* @see https://ariakit.com/components/visually-hidden
* @example
* ```jsx
* <a href="#">
*   Learn more<VisuallyHidden> about the Solar System</VisuallyHidden>.
* </a>
* ```
*/
const VisuallyHidden = forwardRef(function VisuallyHidden(props) {
	return createElement(TagName, useVisuallyHidden(props));
});
//#endregion
export { VisuallyHidden, getVisuallyHiddenStyle, useVisuallyHidden };

//# sourceMappingURL=visually-hidden.js.map